import { create } from 'zustand';

interface LoginModalState {
  isOpen: boolean;
  forceOpen: boolean; // Force modal to show even when user is authenticated
  redirectOnCancel: string;
  title?: string;
  description?: string;
  openLogin: (options?: {
    redirectOnCancel?: string;
    title?: string;
    description?: string;
    force?: boolean;
  }) => void;
  closeLogin: () => void;
}

export const useLoginModal = create<LoginModalState>((set) => ({
  isOpen: false,
  forceOpen: false,
  redirectOnCancel: '/',
  title: undefined,
  description: undefined,

  openLogin: (options = {}) => {
    set({
      isOpen: true,
      forceOpen: options.force || false,
      redirectOnCancel: options.redirectOnCancel || '/',
      title: options.title,
      description: options.description,
    });
  },

  closeLogin: () =>
    set({
      isOpen: false,
      forceOpen: false,
      title: undefined,
      description: undefined,
    }),
}));
